/**
 * Types for Tenant FSP Profile — v31-1-10
 */

export interface FspRepresentative {
  id: number;
  fsp_profile_id: number;
  name: string;
  rep_number: string;
  supervised_until: string | null;
  active: boolean;
  created_at: string | null;
}

export interface FspMandate {
  id: number;
  fsp_profile_id: number;
  name: string;
  risk_profile: string;
  benchmark: string | null;
  constraints_json: Record<string, unknown> | null;
  created_at: string | null;
}

export interface FspProfile {
  id: number;
  organization_id: number;
  fsp_name: string;
  fsp_number: string;
  categories: string[];
  sub_categories_cat1: string[] | null;
  sub_categories_cat2: string[] | null;
  licence_verified_at: string | null;
  licence_verified_by: string | null;
  created_at: string | null;
  updated_at: string | null;
  representatives: FspRepresentative[];
  mandates: FspMandate[];
}

export interface FspProfileCreateRequest {
  fsp_name: string;
  fsp_number: string;
  categories: string[];
  sub_categories_cat1?: string[];
  sub_categories_cat2?: string[];
}

export interface FspProfileUpdateRequest {
  fsp_name?: string;
  fsp_number?: string;
  categories?: string[];
  sub_categories_cat1?: string[];
  sub_categories_cat2?: string[];
}

export interface RepresentativeCreateRequest {
  name: string;
  rep_number: string;
  supervised_until?: string;
  active?: boolean;
}

export interface RepresentativeUpdateRequest {
  name?: string;
  rep_number?: string;
  supervised_until?: string;
  active?: boolean;
}

export interface MandateCreateRequest {
  name: string;
  risk_profile: string;
  benchmark?: string;
  constraints_json?: Record<string, unknown>;
}

export interface MandateUpdateRequest {
  name?: string;
  risk_profile?: string;
  benchmark?: string;
  constraints_json?: Record<string, unknown>;
}

// Canonical sub-category options
export const CAT1_SUB_CATEGORIES = [
  'shares',
  'bonds',
  'money_market',
  'collective_investments',
  'retirement_funds',
  'long_term_deposits',
  'short_term_deposits',
] as const;

export const CAT2_SUB_CATEGORIES = [
  'discretionary_portfolio_management',
] as const;
